export enum DocumentTypeLink {
  None = 0,
  Service = 1,
  ServiceProvider = 2,
  Agent = 3
}


export class DocumentTypeLinkConverter {

  public static GetValueById(enumText: string): number {

    switch (enumText) {
      case 'None':
        return 0;
      case 'Service':
        return 1;
      case 'ServiceProvider':
        return 2;
      case 'Agent':
        return 3;
    }

    return 0;

  }


  public static getDocumentTypeLinkTranslation(linkType: string) {
    switch (linkType) {
      case 'None':
        return "Без връзка";
      case 'Service':
        return "Услуга";
      case 'ServiceProvider':
        return "Доставчик на Услуги";
      case 'Agent':
        return "Посредник";
    }

    return "";
  }

}
